var map = {
	"./App": 50,
	"./App.vue": 50,
	"./assets/css/_base.scss": 1919,
	"./assets/css/_prefixes.scss": 6634,
	"./assets/css/_reset.scss": 8485,
	"./assets/css/_shared.scss": 4247,
	"./assets/css/_tools.scss": 2233,
	"./assets/css/style.scss": 6882,
	"./assets/imgs/about/disclaimer.png": 6218,
	"./assets/imgs/about/disclaimer@2x.png": 7274,
	"./assets/imgs/about/disclaimer@3x.png": 2725,
	"./assets/imgs/about/disclaimer@4x.png": 3084,
	"./assets/imgs/about/erc7160.png": 7205,
	"./assets/imgs/about/erc7160@2x.png": 1775,
	"./assets/imgs/about/erc7160@3x.png": 8932,
	"./assets/imgs/about/erc7160@4x.png": 5101,
	"./assets/imgs/about/gamification.png": 1872,
	"./assets/imgs/about/gamification@2x.png": 4152,
	"./assets/imgs/about/gamification@3x.png": 6931,
	"./assets/imgs/about/gamification@4x.png": 622,
	"./assets/imgs/about/manifesto.png": 2045,
	"./assets/imgs/about/manifesto@2x.png": 4103,
	"./assets/imgs/about/manifesto@3x.png": 716,
	"./assets/imgs/about/manifesto@4x.png": 4005,
	"./assets/imgs/about/perks.png": 9896,
	"./assets/imgs/about/perks@2x.png": 9408,
	"./assets/imgs/about/perks@3x.png": 3659,
	"./assets/imgs/about/perks@4x.png": 6262,
	"./assets/imgs/auction/auction-time.png": 672,
	"./assets/imgs/auction/auction-time@2x.png": 8968,
	"./assets/imgs/auction/auction-time@3x.png": 5923,
	"./assets/imgs/auction/auction-time@4x.png": 5774,
	"./assets/imgs/auction/bid-coin.png": 5546,
	"./assets/imgs/auction/bid-coin@2x.png": 7146,
	"./assets/imgs/auction/bid-coin@3x.png": 2597,
	"./assets/imgs/auction/bid-coin@4x.png": 9308,
	"./assets/imgs/auction/coins.png": 6837,
	"./assets/imgs/auction/coins@2x.png": 8207,
	"./assets/imgs/auction/coins@3x.png": 7956,
	"./assets/imgs/auction/coins@4x.png": 6109,
	"./assets/imgs/auction/tiers.png": 1524,
	"./assets/imgs/auction/tiers@2x.png": 9684,
	"./assets/imgs/auction/tiers@3x.png": 6639,
	"./assets/imgs/auction/tiers@4x.png": 8002,
	"./assets/imgs/back.svg": 5980,
	"./assets/imgs/contrib/contrib.png": 1556,
	"./assets/imgs/contrib/contrib@2x.png": 2500,
	"./assets/imgs/contrib/contrib@3x.png": 9455,
	"./assets/imgs/contrib/contrib@4x.png": 818,
	"./assets/imgs/down-icon.svg": 6049,
	"./assets/imgs/down.svg": 2797,
	"./assets/imgs/forward.svg": 4120,
	"./assets/imgs/gem/evo-mint.svg": 5720,
	"./assets/imgs/gem/gem-protocol.png": 9787,
	"./assets/imgs/gem/gem-protocol@2x.png": 3605,
	"./assets/imgs/gem/gem-protocol@3x.png": 1325,
	"./assets/imgs/gem/gem-protocol@4x.png": 9255,
	"./assets/imgs/goat-nft-1.jpg": 5357,
	"./assets/imgs/goat-nft-2.jpg": 1810,
	"./assets/imgs/home-buttons-bg.svg": 7372,
	"./assets/imgs/home/home-bg.png": 4622,
	"./assets/imgs/home/home-bg@2x.png": 6166,
	"./assets/imgs/home/home-bg@3x.png": 6625,
	"./assets/imgs/home/home-bg@4x.png": 4560,
	"./assets/imgs/icon-disclaimer.svg": 5846,
	"./assets/imgs/icon-manifesto.svg": 4131,
	"./assets/imgs/img-icon.png": 1436,
	"./assets/imgs/info-icon.svg": 4553,
	"./assets/imgs/invitations/header.svg": 1357,
	"./assets/imgs/logo-light.svg": 2799,
	"./assets/imgs/logo-notext.svg": 6357,
	"./assets/imgs/logo.svg": 2292,
	"./assets/imgs/nft-grid-0.png": 6131,
	"./assets/imgs/rewards/banner-bg.svg": 6908,
	"./assets/imgs/rewards/decor-2-left.svg": 6474,
	"./assets/imgs/rewards/decor-2-right.svg": 6321,
	"./assets/imgs/rewards/decor-3-left.svg": 9509,
	"./assets/imgs/rewards/decor-3-right.svg": 8536,
	"./assets/imgs/rewards/decor-left.svg": 1021,
	"./assets/imgs/rewards/decor-right.svg": 4176,
	"./assets/imgs/rewards/headphones.png": 9943,
	"./assets/imgs/rewards/headphones@2x.png": 9177,
	"./assets/imgs/rewards/headphones@3x.png": 2478,
	"./assets/imgs/rewards/headphones@4x.png": 5139,
	"./assets/imgs/rewards/risk-free.png": 3412,
	"./assets/imgs/rewards/risk-free@2x.png": 5380,
	"./assets/imgs/rewards/risk-free@3x.png": 1135,
	"./assets/imgs/rewards/risk-free@4x.png": 7346,
	"./assets/imgs/rewards/star.svg": 7786,
	"./assets/imgs/rewards/trip.png": 7667,
	"./assets/imgs/rewards/trip@2x.png": 7693,
	"./assets/imgs/rewards/trip@3x.png": 2690,
	"./assets/imgs/rewards/trip@4x.png": 9567,
	"./assets/imgs/rewards/watch.png": 5937,
	"./assets/imgs/rewards/watch@2x.png": 8563,
	"./assets/imgs/rewards/watch@3x.png": 3336,
	"./assets/imgs/rewards/watch@4x.png": 3129,
	"./assets/imgs/rounds/chest.png": 2032,
	"./assets/imgs/rounds/chest@2x.png": 392,
	"./assets/imgs/rounds/chest@3x.png": 7347,
	"./assets/imgs/rounds/chest@4x.png": 1694,
	"./assets/imgs/rounds/double-reward.png": 8634,
	"./assets/imgs/rounds/double-reward@2x.png": 1066,
	"./assets/imgs/rounds/double-reward@3x.png": 5605,
	"./assets/imgs/rounds/double-reward@4x.png": 4492,
	"./assets/imgs/rounds/fence.png": 292,
	"./assets/imgs/rounds/fence@2x.png": 6500,
	"./assets/imgs/rounds/fence@3x.png": 9279,
	"./assets/imgs/rounds/fence@4x.png": 3906,
	"./assets/imgs/rounds/gifts.png": 5218,
	"./assets/imgs/rounds/gifts@2x.png": 4658,
	"./assets/imgs/rounds/gifts@3x.png": 3693,
	"./assets/imgs/rounds/gifts@4x.png": 1892,
	"./assets/imgs/rounds/goat-badge.png": 6436,
	"./assets/imgs/rounds/goat-badge@2x.png": 1972,
	"./assets/imgs/rounds/goat-badge@3x.png": 2223,
	"./assets/imgs/rounds/goat-badge@4x.png": 4738,
	"./assets/imgs/rounds/goat.png": 142,
	"./assets/imgs/rounds/goat@2x.png": 6806,
	"./assets/imgs/rounds/goat@3x.png": 7585,
	"./assets/imgs/rounds/goat@4x.png": 6352,
	"./assets/imgs/rounds/shares.png": 6628,
	"./assets/imgs/rounds/shares@2x.png": 4614,
	"./assets/imgs/rounds/shares@3x.png": 7406,
	"./assets/imgs/rounds/shares@4x.png": 7555,
	"./assets/imgs/rounds/target.png": 852,
	"./assets/imgs/rounds/target@2x.png": 7492,
	"./assets/imgs/rounds/target@3x.png": 4447,
	"./assets/imgs/rounds/target@4x.png": 5810,
	"./assets/imgs/rounds/ticket.png": 7123,
	"./assets/imgs/rounds/ticket@2x.png": 2029,
	"./assets/imgs/rounds/ticket@3x.png": 4914,
	"./assets/imgs/rounds/ticket@4x.png": 9020,
	"./assets/imgs/rounds/time-limit.png": 5986,
	"./assets/imgs/rounds/time-limit@2x.png": 3986,
	"./assets/imgs/rounds/time-limit@3x.png": 8989,
	"./assets/imgs/rounds/time-limit@4x.png": 5844,
	"./assets/imgs/site-discord.svg": 7511,
	"./assets/imgs/site-warpcast.svg": 734,
	"./assets/imgs/site-web.svg": 1933,
	"./assets/imgs/site-x.svg": 9887,
	"./assets/imgs/survey/help.svg": 9111,
	"./assets/imgs/survey/wallet.png": 9019,
	"./assets/imgs/survey/wallet@2x.png": 5461,
	"./assets/imgs/survey/wallet@3x.png": 5562,
	"./assets/imgs/survey/wallet@4x.png": 1111,
	"./assets/imgs/tiers-sheet.svg": 7094,
	"./assets/imgs/x.svg": 8203,
	"./assets/test.svg": 1566,
	"./assets/vids/gem-header.mp4": 8392,
	"./assets/vids/intro-1.mp4": 3981,
	"./assets/vids/intro-2.mp4": 4666,
	"./assets/vids/intro-3.mp4": 3263,
	"./assets/vids/intro-4.mp4": 540,
	"./backend": 791,
	"./backend.js": 791,
	"./components/AssetPreloader": 519,
	"./components/AssetPreloader.vue": 519,
	"./components/BaseButton": 8259,
	"./components/BaseButton.vue": 8259,
	"./components/ButtonLayout": 892,
	"./components/ButtonLayout.vue": 892,
	"./components/CountdownElement": 7279,
	"./components/CountdownElement.vue": 7279,
	"./components/HelloWorld": 5050,
	"./components/HelloWorld.vue": 5050,
	"./components/InfoBox": 7157,
	"./components/InfoBox.vue": 7157,
	"./components/InfoLayout1": 7407,
	"./components/InfoLayout1.vue": 7407,
	"./components/InfoLayout2": 7925,
	"./components/InfoLayout2.vue": 7925,
	"./components/LoadingOverlay": 6191,
	"./components/LoadingOverlay.vue": 6191,
	"./components/ModalPopUp": 8146,
	"./components/ModalPopUp.vue": 8146,
	"./components/PageBaseLayout": 2142,
	"./components/PageBaseLayout.vue": 2142,
	"./components/PageManager": 8654,
	"./components/PageManager.vue": 8654,
	"./components/ScrollableContainer": 9779,
	"./components/ScrollableContainer.vue": 9779,
	"./components/SlideIntroLayout": 1590,
	"./components/SlideIntroLayout.vue": 1590,
	"./components/SurveyLayout": 3418,
	"./components/SurveyLayout.vue": 3418,
	"./components/VoteBox": 1910,
	"./components/VoteBox.vue": 1910,
	"./components/VoteCard": 935,
	"./components/VoteCard.vue": 935,
	"./components/VoteSimulation": 7644,
	"./components/VoteSimulation.vue": 7644,
	"./data/pagesData": 9356,
	"./data/pagesData.js": 9356,
	"./errors": 8732,
	"./errors.js": 8732,
	"./main": 1406,
	"./main.js": 1406,
	"./pages": 2079,
	"./pages.js": 2079,
	"./pages/AlphaGoat/AlphaGoat01": 389,
	"./pages/AlphaGoat/AlphaGoat01.vue": 389,
	"./pages/AlphaGoat/AlphaGoat01S2": 7245,
	"./pages/AlphaGoat/AlphaGoat01S2.vue": 7245,
	"./pages/AlphaGoat/AlphaGoat01S3": 8561,
	"./pages/AlphaGoat/AlphaGoat01S3.vue": 8561,
	"./pages/AlphaGoat/AlphaGoat01S4": 2122,
	"./pages/AlphaGoat/AlphaGoat01S4.vue": 2122,
	"./pages/AlphaGoat/AlphaGoat01Tiers": 766,
	"./pages/AlphaGoat/AlphaGoat01Tiers.vue": 766,
	"./pages/AlphaGoat/AlphaGoat02": 5140,
	"./pages/AlphaGoat/AlphaGoat02.vue": 5140,
	"./pages/AlphaGoat/AlphaGoat03": 6704,
	"./pages/AlphaGoat/AlphaGoat03.vue": 6704,
	"./pages/AlphaGoat/AlphaGoat04": 4940,
	"./pages/AlphaGoat/AlphaGoat04.vue": 4940,
	"./pages/AlphaGoat/category": 1332,
	"./pages/AlphaGoat/category.json": 1332,
	"./pages/AlphaGoatClub/HomePage": 354,
	"./pages/AlphaGoatClub/HomePage.vue": 354,
	"./pages/AlphaGoatClub/category": 788,
	"./pages/AlphaGoatClub/category.json": 788,
	"./pages/AlphaLabs/WhoAlphaLabs00": 7811,
	"./pages/AlphaLabs/WhoAlphaLabs00.vue": 7811,
	"./pages/AlphaLabs/WhoAlphaLabs01": 9139,
	"./pages/AlphaLabs/WhoAlphaLabs01.vue": 9139,
	"./pages/AlphaLabs/WhoAlphaLabs02": 5107,
	"./pages/AlphaLabs/WhoAlphaLabs02.vue": 5107,
	"./pages/AlphaLabs/category": 6121,
	"./pages/AlphaLabs/category.json": 6121,
	"./pages/Contribution/MorePerks00": 1438,
	"./pages/Contribution/MorePerks00.vue": 1438,
	"./pages/Contribution/MorePerks01": 7058,
	"./pages/Contribution/MorePerks01.vue": 7058,
	"./pages/Contribution/SurveyPage01": 2863,
	"./pages/Contribution/SurveyPage01.vue": 2863,
	"./pages/Contribution/SurveyPage02": 9835,
	"./pages/Contribution/SurveyPage02.vue": 9835,
	"./pages/Contribution/SurveyPage03": 3572,
	"./pages/Contribution/SurveyPage03.vue": 3572,
	"./pages/Contribution/SurveyPage04": 9961,
	"./pages/Contribution/SurveyPage04.vue": 9961,
	"./pages/Contribution/SurveyPage05": 3840,
	"./pages/Contribution/SurveyPage05.vue": 3840,
	"./pages/Contribution/SurveyPage06": 7780,
	"./pages/Contribution/SurveyPage06.vue": 7780,
	"./pages/Contribution/SurveyPage07": 1930,
	"./pages/Contribution/SurveyPage07.vue": 1930,
	"./pages/Contribution/SurveyPage08": 9233,
	"./pages/Contribution/SurveyPage08.vue": 9233,
	"./pages/Contribution/SurveyPage09": 5219,
	"./pages/Contribution/SurveyPage09.vue": 5219,
	"./pages/Contribution/SurveyPage10": 5244,
	"./pages/Contribution/SurveyPage10.vue": 5244,
	"./pages/Contribution/SurveyPage11": 3731,
	"./pages/Contribution/SurveyPage11.vue": 3731,
	"./pages/Contribution/SurveyPageEnd": 8554,
	"./pages/Contribution/SurveyPageEnd.vue": 8554,
	"./pages/Contribution/category": 2767,
	"./pages/Contribution/category.json": 2767,
	"./pages/GEMMechanism/GemMechanism01": 1338,
	"./pages/GEMMechanism/GemMechanism01.vue": 1338,
	"./pages/GEMMechanism/GemMechanism02": 6375,
	"./pages/GEMMechanism/GemMechanism02.vue": 6375,
	"./pages/GEMMechanism/GemMechanism03": 6920,
	"./pages/GEMMechanism/GemMechanism03.vue": 6920,
	"./pages/GEMMechanism/GemMechanism04": 1989,
	"./pages/GEMMechanism/GemMechanism04.vue": 1989,
	"./pages/GEMMechanism/GemMechanism05": 7115,
	"./pages/GEMMechanism/GemMechanism05.vue": 7115,
	"./pages/GEMMechanism/GemMechanism06": 6034,
	"./pages/GEMMechanism/GemMechanism06.vue": 6034,
	"./pages/GEMMechanism/GemMechanism07": 3188,
	"./pages/GEMMechanism/GemMechanism07.vue": 3188,
	"./pages/GEMMechanism/GemMechanism08": 1108,
	"./pages/GEMMechanism/GemMechanism08.vue": 1108,
	"./pages/GEMMechanism/GemMechanism09Lose": 2846,
	"./pages/GEMMechanism/GemMechanism09Lose.vue": 2846,
	"./pages/GEMMechanism/GemMechanism09Win": 2454,
	"./pages/GEMMechanism/GemMechanism09Win.vue": 2454,
	"./pages/GEMMechanism/GemMechanism10Lose": 1558,
	"./pages/GEMMechanism/GemMechanism10Lose.vue": 1558,
	"./pages/GEMMechanism/GemMechanism10Win": 7412,
	"./pages/GEMMechanism/GemMechanism10Win.vue": 7412,
	"./pages/GEMMechanism/GemMechanism11": 9910,
	"./pages/GEMMechanism/GemMechanism11.vue": 9910,
	"./pages/GEMMechanism/GemMechanism12": 906,
	"./pages/GEMMechanism/GemMechanism12.vue": 906,
	"./pages/GEMMechanism/GemMechanism13": 532,
	"./pages/GEMMechanism/GemMechanism13.vue": 532,
	"./pages/GEMMechanism/GemMechanism14": 6620,
	"./pages/GEMMechanism/GemMechanism14.vue": 6620,
	"./pages/GEMMechanism/GemMechanism15": 9430,
	"./pages/GEMMechanism/GemMechanism15.vue": 9430,
	"./pages/GEMMechanism/GemMechanism16": 7505,
	"./pages/GEMMechanism/GemMechanism16.vue": 7505,
	"./pages/GEMMechanism/category": 5457,
	"./pages/GEMMechanism/category.json": 5457,
	"./pages/HonoraryInvitations/HonoraryInvitations00": 6221,
	"./pages/HonoraryInvitations/HonoraryInvitations00.vue": 6221,
	"./pages/HonoraryInvitations/HonoraryInvitations01": 278,
	"./pages/HonoraryInvitations/HonoraryInvitations01.vue": 278,
	"./pages/HonoraryInvitations/category": 3439,
	"./pages/HonoraryInvitations/category.json": 3439,
	"./pages/Rewards/RewardsView": 2480,
	"./pages/Rewards/RewardsView.vue": 2480,
	"./pages/Rewards/category": 5749,
	"./pages/Rewards/category.json": 5749,
	"./pages/Test/TestPage": 9189,
	"./pages/Test/TestPage.vue": 9189,
	"./pages/Test/TestPage2": 7026,
	"./pages/Test/TestPage2.vue": 7026,
	"./pages/Test/TestPage3": 8191,
	"./pages/Test/TestPage3.vue": 8191,
	"./pages/Test/TestPage4": 9731,
	"./pages/Test/TestPage4.vue": 9731,
	"./pages/Test/category": 3533,
	"./pages/Test/category.json": 3533,
	"./storage": 5186,
	"./storage.js": 5186,
	"./survey": 7961,
	"./survey.js": 7961,
	"./telegramManager": 4333,
	"./telegramManager.js": 4333,
	"./videoManager": 3461,
	"./videoManager.js": 3461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5538;